import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { googleAdsConfig } from './servicePageConfigs';

const GoogleAdsService = () => <ServicePageTemplate {...googleAdsConfig} />;

export default GoogleAdsService;
